module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/504d73be1b361b4b9ca7f655ce085dc6.svg";